import React, { Component } from 'react'
import { Switch, Route, withRouter } from "react-router-dom";
import Documentadas from './documentadas/Documentadas';
// import Embarcadas from './embarcadas/Embarcadas';
import Listado from './guias/Guias';
import Embarques from './embarques/Embarques';
import Embarcar from './embarques/Embarcar';
import EmbarqueSalida from './embarques/Salida';
import { AuthContext } from "../../context/authContext";
import Entregas from './entregas/Entregas';
// import Documentacion from "./Documentar/Documentacion";
import Documentacion from "./Documentar/DocumentacionNew";
import GuiasEspeciales from './especiales/GuiasEspeciales';
import ProductosEspeciales from './productosEspeciales/ProductosEspeciales';
import FacturasEnviadas from '../Ventas/facturacion/GuiasEnviadas';
import GuiasNoConfirmadas from './confirmarCYC/GuiasNoConfirmadas';
import EnvioFacturas from '../Ventas/facturacion/EnvioGuias';
import TablaEvidencias from './revisionEvidencias/tablaEvidencias';
import EscaneoEvidencia from './escaneoEvidencias/EscaneoEvidencias';
import SeguimientoGuias from './seguimientoGuias/seguimientoGuias';
import ImpresionMultiple from './impresionMultiple/impresionMultiple';
import EtiquetaGuiasTable from './Etiqueta/EtiquetaGuiasTable';
import EtiquetasTable from './Etiqueta/EtiquetasTable';
import DesembarcarGuias from './embarques/DesembarcarGuias';
import EmbarqueCartasPorte from './embarques/EmbarqueCartasPorte';
import ACCESS from '../../ACCESS';

class Guias extends Component {
  constructor(props) {
    super(props);
    this.rutas = [
      // { path: `${this.props.match.path}/NuevaGuia`, Componente: Documentacion, accion: 'show' },
      {
        path: `${this.props.match.path}/Guia/:id?`, Componente: Documentacion, accion: 'show', access: [ACCESS.GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.VER_TODAS_GUIAS, ACCESS.GUIA.VER_GUIAS_CLIENTE_DEL_USUARIO
        ]
      },
      {
        path: `${this.props.match.path}/Todas`, Componente: Listado, accion: 'show', access: [ACCESS.GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.VER_TODAS_GUIAS, ACCESS.GUIA.VER_GUIAS_CLIENTE_DEL_USUARIO
        ]
      },
      { path: `${this.props.match.path}/EntregaDomicilio`, Componente: Documentadas, accion: 'show', access: [ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_CREADAS_POR_EL_USUARIO, ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_SUCURSAL_DEL_USUARIO,
        ACCESS.MARCAR_ENTREGAS.VER_TODAS_LAS_GUIAS_PENDIENTES_DE_ENTREGA
      ] },
      /* { path: `${this.props.match.path}/Embarcadas`, Componente: Embarcadas, accion: 'show' }, */
      { path: `${this.props.match.path}/Embarques`, Componente: Embarques, accion: 'show', access: [ACCESS.EMBARQUE.VER_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.VER_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.VER_TODAS_EMBARQUES] },
      { path: `${this.props.match.path}/Embarque/:id/Salida`, Componente: EmbarqueSalida, accion: 'show', access: [ACCESS.EMBARQUE.VER_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.VER_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.VER_TODAS_EMBARQUES] },
      { path: `${this.props.match.path}/Embarque/:id/Desembarque`, Componente: DesembarcarGuias, accion: 'show', access: [ACCESS.EMBARQUE.DESEMBARQUE_GUIAS] },
      { path: `${this.props.match.path}/Embarque/:id/CartaPorte`, Componente: EmbarqueCartasPorte, accion: 'show', access: [ACCESS.EMBARQUE.GENERAR_CARTA_PORTE_DEL_EMBARQUE] },
      { path: `${this.props.match.path}/Embarque/:id`, Componente: Embarcar, accion: 'show', access: [ACCESS.EMBARQUE.VER_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.VER_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.VER_TODAS_EMBARQUES] },
      { path: `${this.props.match.path}/Entregas`, Componente: Entregas, accion: 'show', access: [ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_CREADAS_POR_EL_USUARIO, 
        ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_SUCURSAL_DEL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.VER_TODAS_ASIGNACIONES] },
      /* { path: `${this.props.match.path}/Desembarcadas`, Componente: Desembarcadas, accion: 'show' }, */
      { path: `${this.props.match.path}/Especiales`, Componente: GuiasEspeciales, accion: 'show', access: [ACCESS.GUIA.ARCHIVO_CONCORD, ACCESS.GUIA.ARCHIVO_FLEXI, ACCESS.GUIA.ARCHIVO_ULINE, ACCESS.GUIA.ARCHIVO_PRODUCTOS_3M] },
      { path: `${this.props.match.path}/ProductosEspeciales`, Componente: ProductosEspeciales, accion: 'show', access: [ACCESS.GUIA.ARCHIVO_PRODUCTOS_3M, ACCESS.GUIA.ARCHIVO_PRODUCTOS_ULINE] },
      { path: `${this.props.match.path}/FacturasEnviadas`, Componente: FacturasEnviadas, accion: 'show', access: [ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_CREADOS_POR_EL_USUARIO, ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_SUCURSAL_DEL_USUARIO,
          ACCESS.ENVIO_GUIAS_CYC.VER_TODOS_LOS_FOLIOS] },
      { path: `${this.props.match.path}/PendientesCYC`, Componente: GuiasNoConfirmadas, accion: 'show', access: [ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_SUCURSAL_DEL_USUARIO,
        ACCESS.GUIAS_PENDIENTES_CYC.VER_TODAS_LAS_GUIAS] },
      { path: `${this.props.match.path}/EnvioFacturas/:id?`, Componente: EnvioFacturas, accion: 'show', access: [ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_CREADOS_POR_EL_USUARIO, ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_SUCURSAL_DEL_USUARIO,
        ACCESS.ENVIO_GUIAS_CYC.VER_TODOS_LOS_FOLIOS] },
      { path: `${this.props.match.path}/RevisionEvidencias`, Componente: TablaEvidencias, accion: 'show', access: [ACCESS.REVISION_EVIDENCIAS.VER_EVIDENCIAS] },
      { path: `${this.props.match.path}/EscaneoEvidencias`, Componente: EscaneoEvidencia, accion: 'show', access: [ACCESS.ESCANEO_EVIDENCIAS.ESCANEAR_EVICENCIAS] },
      { path: `${this.props.match.path}/SeguimientoGuias`, Componente: SeguimientoGuias, accion: 'show', access: [ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO,
        ACCESS.SEGUIMIENTO_DE_GUIA.VER_TODAS_GUIAS] },
      { path: `${this.props.match.path}/ImpresionMultiple`, Componente: ImpresionMultiple, accion: 'show', access: [ACCESS.IMPRESION_MULTIPLE_GUIAS.IMPRIMIR_GUIAS] },
      { path: `${this.props.match.path}/Etiquetas`, Componente: EtiquetaGuiasTable, accion: 'show', access: [ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO, 
        ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO, ACCESS.SEGUIMIENTO_ETIQUETAS.VER_TODAS_ETIQUETAS] },
      { path: `${this.props.match.path}/Etiqueta/:id?`, Componente: EtiquetasTable, accion: 'show', access: [ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO, 
        ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO, ACCESS.SEGUIMIENTO_ETIQUETAS.VER_TODAS_ETIQUETAS] },
    ];
    this.state = {
      recursos: []
    };
  }

  componentDidMount() {
    let { hasAccess } = this.context;
    let validResources = this.rutas.filter(r => hasAccess(r.access));
    this.setState({ recursos: validResources });
  }

  render() {
    return (
      <div style={{ padding: 10 }}>
        <Switch>
          {
            this.state.recursos.map((recurso, index) => (
              <Route key={`ruta-${index}`} path={recurso.path}>
                <recurso.Componente />
              </Route>)
            )
          }
          {/* <Route path={`${this.props.match.path}/Desembarcadas`}>
            <Confirmacion></Confirmacion>
          </Route> */}
          {/* <Route path={`${this.props.match.path}/Asignadas`}>
            <Recepciones></Recepciones>
          </Route> */}
        </Switch>
      </div>
    )
  }
}
Guias.contextType = AuthContext;
export default withRouter(Guias)